import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { Injectable } from '@angular/core'

@Injectable()
export class CompoundSettingsService {
  constructor(private http: HttpClient) {}

  public fetchCompoundSettings(params: object = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_COMPOUNDS`
    return this.http.get(url, params)
  }

  public updateCompoundSettings(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_COMPOUNDS`
    return this.http.put(url, params)
  }
}
